import { useTranslation } from "react-i18next";
import type { ChangeCounts } from "../../api/content/importProposalsApi";
import AppButton from "../../ui/buttons/AppButton";

export function ChangeCountsLine({ counts }: { counts: ChangeCounts }) {
  const { t } = useTranslation();
  return <p className="app-text-muted text-xs">{t("importProposals.page.counts", { ...counts })}</p>;
}

export function ChangePageControls({ offset, limit, nextOffset, total, onPage }: {
  offset: number; limit: number; nextOffset: number | null; total: number; onPage: (offset: number) => void;
}) {
  const { t } = useTranslation();
  return (
    <nav className="flex items-center gap-2 text-xs" aria-label={t("importProposals.page.pagination")}>
      <AppButton variant="secondary" size="sm" disabled={offset === 0} onClick={() => { onPage(Math.max(0, offset - limit)); }}>{t("importProposals.page.previous")}</AppButton>
      <span>{t("importProposals.page.range", { start: total === 0 ? 0 : offset + 1, end: Math.min(offset + limit, total), total })}</span>
      <AppButton variant="secondary" size="sm" disabled={nextOffset === null} onClick={() => { if (nextOffset !== null) onPage(nextOffset); }}>{t("importProposals.page.next")}</AppButton>
    </nav>
  );
}
